import { render, staticRenderFns } from "./EditTalker.vue?vue&type=template&id=adeb65c2&scoped=true&"
import script from "./EditTalker.vue?vue&type=script&lang=js&"
export * from "./EditTalker.vue?vue&type=script&lang=js&"
import style0 from "./EditTalker.vue?vue&type=style&index=0&id=adeb65c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adeb65c2",
  null
  
)

export default component.exports